let urls = {
  // START TEST SERVER
  XMPP_BASE: 'chatxmpp.redhotpie.com.au',
  XMPP_IMURL: 'wss://tstchatxmpp8.redhotpie.com.au:5222/',
  BASE_URL: 'https://tstchatapi.redhotpie.com.au:2083',
  BASE_RHPURL: 'https://srvtstsiq.redhotpie.com.au/', // https://srvsrc1.redhotpie.com.au, 'https://srvsr.redhotpie.com.au'
  AUT_RHPURL: 'https://tstauth.redhotpie.com.au', // https://authrc1.redhotpie.com.au, 'https://authr.redhotpie.com.au'
  LIVE_STREAM_HOST: 'https://tstantmds.redhotpie.com.au:5443/WebRTCAppEE/rest',
  WSS_LIVE_STREAM: 'wss://tstantmds.redhotpie.com.au:5443/WebRTCAppEE/websocket',
  FACE_LIVENESS_SERVER: 'https://tstrg.redhotpie.com.au:41101',
  // END TEST SERVER

  // LIVESTREAM
  STUN_SERVER: 'stun:stun.l.google.com:19302',
  TURN_SERVER: 'turn:chatturn.redhotpie.com.au:5349',
  // TURN_SERVER: "turn:streaming.nexlesoft.com:5349",
  CREDENTIAL_USERNAME_TURN_SERVER: 'redhotpie',
  CREDENTIAL_PASSWORD_TURN_SERVER: 'redhotpie',

  MOCK_URL: 'https://private-a864c6-realitimemessengerextract.apiary-mock.com',
  NEW_BASE_RHPURL: 'https://tstdq.redhotpie.com.au',

  // AUT_RHPURL: 'https://dsitst.redhotpie.com.au',
  DEV_RHPURL: 'https://dsitst.redhotpie.com.au',
  PROD_RHPURL: 'https://redhotpie.com.au', // https://betatest.redhotpie.com.au,
  // LiveStream
  //  DEV_XMPP_BASE_LIVESTREAM: 'https://tstchatxmpp.redhotpie.com.au',
  //  PRO_XMPP_BASE_LIVESTREAM: 'https://redhotpie.com.au', //'https://betatest.redhotpie.com.au',
  URL_PLAY_YOUTUBE: 'https://www.youtube.com/watch?v=videoCode',
  URL_PLAY_VIMEO: 'https://player.vimeo.com/video/videoCode',
  URL_PLAYER_VIMEO: 'https://player.vimeo.com',
  URL_VIMEO: 'https://vimeo.com',

  DEV_BETA_TEST: 'https://tstchatxmpp.redhotpie.com.au',
  PROD_BETA_TEST: 'https://redhotpie.com.au', // 'https://betatest.redhotpie.com.au',

  FACEBOOK_URL: 'https://graph.facebook.com',
  FACEBOOK_ME_PATH: '/me?fields=email,name,gender,picture&access_token=',

  GOOGLE_URL: 'https://maps.googleapis.com',
  PROXY_URL: 'https://cors-anywhere.herokuapp.com/',
  GOOGLE_AUTOCOMPLETE_PATH: '/maps/api/place/autocomplete/json?input={inputValue}&key={keyValue}',
  GOOGLE_PLACE_DETAILS_PATH: '/maps/api/place/details/json?placeid={placeidValue}&key={keyValue}',
  GET_GOOGLE_PLACE_DETAILS_PATH:
    '/maps/api/geocode/json?latlng={lat},{lng}&result_type=administrative_area_level_3%7Clocality&key={keyValue}',
  GET_GOOGLE_PLACE_DETAILS_PATH_FULL: '/maps/api/geocode/json?latlng={lat},{lng}&key={keyValue}',
  GET_GOOGLE_GEO_LOCATION_PATH: '/geolocation/v1/geolocate?key={keyValue}',
  // WRAP LOCATION
  GET_LOCATION: '/locations/{inputValue}/type/{typeValue}',
  GET_LOCATION_BY_PLACE_ID: '/locations/place/{placeidValue}',
  GET_LOCATION_BY_GEO: '/locations/place/lat/{lat}/lng/{lng}/resultType/administrative_area_level_1',
  USER_LOGIN: '/login',
  GET_ANONYMOUS_ACCESS_TOKEN: '/AccessToken',
  POST_AFFILIATE_TRAFFIC: '/Affiliate/TrafficHit',

  // RHP_AUTHEN
  RHP_LOGIN: '/auth/credentials',
  RHP_LOGIN_WEB: '/api/LoginUser',
  RHP_LOGOUT: '/auth/logout',
  RHP_GET_ACCESSTOKEN: '/access-token',
  RHP_POST_VALIDATE_TOKEN: '/users/validateToken',
  RHP_LOGOUT_DESKTOP: '/MemberProfile/Logout.aspx',
  RHP_LOGOUT_MOBILE: '/mobile/logout.aspx',
  RHP_ACCOUNT_LOOK_UP: '/User/AccountLookup',
  GET_VALIDATE_PROMO_CODE: '/User/PromoCode/{Code}',
  GET_JOIN_LANDING_PAGE: '/JoinLanding/{Code}',

  // LOG
  LOG_CONNECTION: '/log',

  // Conversations
  CONVERSATION_PIN_UNPIN: '/conversation/pinunpin',
  CONVERSATION_DELETE: '/receiver/{receiverXmppid}/messages',
  LIST_CONVERSATION_DELETE: '/conversations',
  CONVERSATION_REPORT: '/conversation/report',

  PATCH_IGNORE_CONVERSATION: '/conversations',

  CONVERSATION: '/conversations',
  CONVERSATION_PINNED: '/conversations/pinned',
  CONVERSATION_DETAILS: '/conversations/receiver/{receiver_xmppid}/messages',
  NEW_CONVERSATION_DETAILS: '/receiver/{receiverXmppId}/messages',
  PIN_CONVERSATION: '/pin',
  UN_PIN_CONVERSATION: '/unpin',
  SEARCH_CONVERSATION: '/search',
  CONVERSATION_UNREAD_COUNT: '/conversations/unreadcount',
  CONVERSATION_CHECK_CAN_SEND: '/Profile/{userId}/MessageAuthorised',
  CONVERSATION_GET_BASE_INFO: '/conversations/receiver/{receiverXmppId}',
  CONVERSATION_GET_NEW: '/conversations?lastSynchAt={lastSynchAt}&isGetNewConversation={isGetNewConversation}',

  // Report User
  REPORT_USER: '/Profiles/{profileId}/Report',

  // Ice breakers
  // ICE_BREAKER_LOAD_ALL: '/icebreaker/',
  ICE_BREAKER_LOAD_ALL: '/Lookup/IceBreaker',

  QUICK_MESSAGE_LOAD_ALL: '/User/Message/Template',
  QUICK_MESSAGE_ADD: '/User/Message/Template',
  QUICK_MESSAGE_UPDATE: '/User/Message/Template/{templateId}',
  QUICK_MESSAGE_DELETE: '/User/Message/Template',

  // USER
  CREATE_ABUSE_REPORT_IMAGE: '/Profiles/Report/{reportId}/Image',
  MERGE_ABUSE_REPORT_VIDEO: 'Profiles/Report/{reportId}/Video/MergeAsync',
  USER_GET_FRIEND_FAVORITE: '/quickmessage/',
  BLOCK_USER: 'Profile/{userId}/Block',
  CREATE_ABUSE_REPORT: '/Profile/{userId}/Report',
  GET_FRIEND_AND_FAVORITE: '/Profile/Search?size={pageSize}&page={pageNumber}',
  GET_PROFILE: '/{userId}',
  GET_PROFILE_SUMMARY: '/Profile/{profileId}/Summary',
  GET_USER_MAIN_PHOTO: '/User/Profile/MainPhoto',
  GET_MAIN_PHOTO: '/Profile/{profileId}/MainPhoto',
  GET_MAIN_PHOTOS: '/Profile/MainPhoto?UserIDs={UserIDs}',
  GET_QUICK_PROFILE: '/users/{xmppId}',
  GET_MY_QUICK_PROFILE: '/users/detail',
  GET_USER_XMPP_DETAIL: '/User/Account/XMPP',
  GET_LIST_MATCHING: '/match',
  ADD_MATCHING_USER: '/match',
  GET_USERS_WHO_BLOCK_ME: '/User/BlockList/Blocking',
  GET_USERS_BLOCKED: '/User/BlockList',
  GET_USERS_BLOCKED_TIGASE: '/block',
  GET_USER_PROFILE: '/User/Profile',
  GET_USER_STATUS: '/users/{userId}/status',
  PATCH_UPDATE_ACCOUNT_SETTING: '/User/Account/Settings/Account',
  CHECK_USER_ONLINE: '/users/getChatUserInfo/{xmppId}',
  UPDATE_ACCOUNT_TOOLTIPS: '/User/ToolTip/{ID}',
  PUT_USER_INFO: '/users/{userId}/info',
  CHECK_USER_BLOCK_ME: '/block/{userId}',
  CHAT_BLOCK: '/block/{userId}',
  CREATE_USER_INVITE: '/User/Invite',
  GET_RECEIVED_INVITES: '/User/Invite/Received/{parentType}',
  DELETE_RECEIVED_INVITES: '/User/Invite/Received/{inviteID}',
  MERGE_USER_VERIFICATION_ASYNC: 'User/Verification/MergeAsync',
  // Message
  DELETE_MESSAGE: '/messages/{messageId}',
  UPDATE_MESSAGE: '/messages/{messageId}',
  UPDATE_MESSAGE_STATUS: '/messages/{messageId}/status',
  UPDATE_MESSAGE_STATE: '/messages/{messageId}/state',
  NOTIFY_MESSAGE_SENT: 'User/Notification/Message',
  LOOKUP_MESSAGE_BY_CONDITION: '/messageIds/receiver',
  // Private album
  GET_PRIVATE_ALBUM_INFO: '/User/Photo/Gallery',
  GET_ALBUM_PHOTOS: '/Profile/{id}/Gallery/{galleryId}',
  GET_USER_GALLERY_ACCESS: '/User/Photo/Gallery/{galleryId}/Access',
  GET_USER_GALLERY_WITH_ACCESS: '/User/Photo/Gallery/Access',
  GRANT_USER_GALLERY_ACCESS: '/User/Photo/Gallery/{galleryId}/Access',
  DELETE_USER_GALLERY_ACCESS: '/User/Photo/Gallery/{galleryId}/Access',
  SET_GALLERY_STATUS: '/Profile/{userId}/Gallery/{galleryId}/{type}',
  SET_GALLERY_RESET: '/Profile/{userId}/Gallery/{galleryId}/Reset',

  // FRIENDS AND FAVOURITES
  ADD_FAVORITE: '/Profile/{userId}/Hot',
  DELETE_FAVORITE: '/User/HotList',

  // Authentication
  GET_TOKEN: '/users/token/{xmppId}',

  // REGISTRATION
  GET_LOOKING_FOR_DATA: '/Lookup/membertypeplural?LookupType=Registration',
  GET_MEMBER_TYPE_DATA: '/Lookup/membertype?LookupType=Registration',
  GET_AGE_RANGE_DATA: './loookingFor',
  GET_INTENTIONS_DATA: '/Lookup/Intention?LookupType=Registration',
  CREATE_ACCOUNT: '/User/Account',
  GET_JOIN_TOKEN: '/User/Account/JoinToken',
  GET_FORGOT_PASSWORD: '/User/Account/PasswordReset',
  GET_RESET_PASSWORD: '/User/PasswordReset',
  POST_SEND_MSG_CODE: '/User/Account/PasswordReset/Mobile/Send',
  POST_VALIDATE_MSG_CODE: '/User/Account/PasswordReset/Mobile/Validate',
  // CONNECT_FACEBOOK: "/api/LoginUserFB",
  AUTH_FACEBOOKID: '/auth/facebookid',
  AUTH_APPLE: '/auth/AppleSignIn',
  AUTH_APPLE_WEB: '/auth/AppleSignInWeb',
  AUTH_GOOGLE: '/auth/GoogleSignIn',
  POST_VALIDATE_PHONE_REQUEST: '/User/Account/Mobile/Send',
  POST_VALIDATE_CODE_REQUEST: '/User/Account/Mobile/Validate',

  // TELL US ABOUT YOUSEFT
  GET_SEX_DATA: './GET_SEX_DATA',
  GET_ETHNICITY_DATA: '/Lookup/race?LookupType=Registration',
  GET_BODY_TYPE_DATA: '/Lookup/bodytype?LookupType=Registration',
  GET_HEIGHT_DATA: '/Lookup/height?LookupType=Registration',
  GET_ORIENTATION_DATA: '/Lookup/Sexual?LookupType=Registration',
  GET_RELATION_SHIP: 'lookup/maritalstatus?lookuptype=registration',
  // WHAT ARE YOUR INTERESTS
  GET_GENERAL_DATA: './Lookup/GeneralInterest?LookupType=Registration',
  GET_SEXUAL_SINGLE_DATA: '/Lookup/SexualInterestSingle?LookupType=Registration',
  GET_SEXUAL_COUPLE_DATA: '/Lookup/SexualInterestCouple?LookupType=Registration',
  GET_FETISH_DATA: '/Lookup/FetishInterest?LookupType=Registration',

  // CREATE ACCOUNT
  CHECK_DUPLICATE_USERNAME: '/LookupAvailability/username?value=',
  CHECK_DUPLICATE_EMAIL: '/LookupAvailability/email?value=',
  TERMS: 'http://rhpmobile.com/termsofservice/',
  PRIVACY: 'http://rhpmobile.com/privacypolicy/',

  // Introduce Yourself
  GET_PERSONALITY_DATA: './ProfileBuilder/personality',
  GET_LOOKS_DATA: './ProfileBuilder/looks',
  GET_INTERESTS_DATA: './ProfileBuilder/interests',
  GET_YOUR_IDEAL_MATCH_DATA: './ProfileBuilder/Seeking?membertype=',

  // MEMBER SEARCH
  GET_USER_SEARCH_SETTINGS: '/User/Search/Settings',
  GET_PROFILE_SEARCH: '/Profile/Search',
  GET_SPOTLIGHT_USER: '/Profile/Search/Spotlight',
  POST_SPOTLIGHT_USER: '/Profile/Search/Spotlight',
  GET_NICHE_SEARCH: '/Profile/Search/NicheSettings',
  GET_LIST_ENTITIES: '/Lookup/{EntitySearch}?LookupType=Search',
  UPDATE_ACTION_USER_SEARCH: '/Profile/{id}/{Action}',
  GET_USER_SAVED_SEARCHES: '/User/Search/Saved',
  DELETE_USER_SAVED_SEARCHES: '/User/Search/Saved/{id}',
  GET_SPOTLIGHT_FEATURED: '/Profile/Search/Spotlight/Featured',

  // MEMBER_PROFILE
  GET_MEMBER_PROFILE: '/Profile/{id}',
  GET_MEMBER_PROFILE_PHOTO: '/Profile/{id}/Photo/All',
  GET_MEMBER_PROFILE_GALLERY: '/Profile/{id}/Gallery',
  GET_MEMBER_PROFILE_AMATEUR_DATA: '/Profile/{id}/Amateur',
  GET_MEMBER_VALIDATE: '/Profile/{id}/Validation',
  GET_MEMBER_VALIDATION_COUNT: '/Profile/{id}/Validation/Count',
  GET_MEMBER_FRIENDS_COUNT: '/Profile/{id}/Friend/Count',
  GET_MEMBER_FRIENDS: '/Profile/{id}/Friend',
  GET_MEMBER_TRAVEL_PLAN: '/Profile/{id}/Travel',
  GET_MEMBER_DATE_FINDER: '/Profile/{id}/DateFinder',
  POST_CREATE_DATE_FINDER_INTEREST: '/DateFinder/{id}/Interest',
  POST_CREATE_DATE_FINDER_UNINTEREST: '/DateFinder/{id}/Uninterest',
  GET_DATE_FINDER_DESCRIPTIONS: '/Lookup/DateFinderDescription',
  GET_DATE_FINDER_MEET_TYPE: '/Lookup/DateFinderMeetType',
  POST_MEMBER_CREATE_VALIDATION: '/Profile/{id}/Validation',
  POST_MEMBER_CREATE_FRIEND: '/Profile/{id}/Friend',
  MEMBER_PROFILE_NOTE: '/Profile/{id}/Note',
  PATCH_MEMBER_PROFILE_NOTE: '/User/Note/{id}',
  PATCH_MEMBER_PROFILE_FRIEND: '/User/Friends',
  GET_PROFILE_GROUPS: '/Profile/{id}/Groups',
  // USER_SETTING
  GET_USER_SETTINGS: '/User/Account/Settings',
  POST_USER_TOOLTIP: '/User/ToolTip/{id}',
  PATH_USER_CLIENT_SETTINGS: '/User/Account/Settings/Client',
  POST_PROFILE_CREATE_REPORT: '/Profiles/{id}/Report',
  PATCH_USER_MESSENGER_SETTINGS: '/User/Account/Settings/Messenger',
  PATCH_USER_CHATROOM_SETTINGS: '/User/Account/Settings/Chatroom',
  GET_MANUAL_PHONE_VERIFICATION_CODE: '/User/Phone/Verification/Code',
  PATCH_USER_MEMBER_TYPE: '/User/MemberType',
  SORT_IMAGE_ORDER: '/User/Photo/SortNumber',
  // MEMBERPROSPEC
  PROSPECTS_USER_PROFILE_VIEW: '/User/ProfileView',
  PROSPECTS_USER_PROFILE_VIEW_GET: '/User/ProfileView/Search',
  PROSPECTS_USER_USER_LIKES: '/User/UserLikes',
  PROSPECTS_USER_USER_LIKES_FAVOURITES: '/User/UserLikesFavourites',
  PROSPECTS_USER_USER_FAV: '/User/UserFavourites',
  PROSPECTS_COUNT: '/User/Prospects/Count',
  PROSPECTS_USER_LIKE_STATE_COUNT: '/User/UserLikes/StateCount',
  PROSPECTS_PROFILE_VIEW_STATE_COUNT: '/User/ProfileView/StateCount',
  // GROUPS CHAT
  GET_GROUPS_CHAT: '/groups-chat',
  GET_PROFILE_SUMMARIES: '/Profile/Summaries?ids={ids}',
  UPDATE_USER_STATUS: '/groups-chat/update-status',
  GET_LIST_USERS_STATUS: '/groups-chat/{roomJid}/users-status',
  AUTHORIZE_CHAT_ROOM: 'User/ChatRoom',
  CREATE_USER_CHATROOM_BAN: '/Profile/{id}/ChatRoomBan',
  GET_NOTE_CHATROOM: '/Profile/{id}/AdminNote',
  POST_NOTE_CHATROOM: '/Profile/{id}/AdminNote',
  GET_FREE_HOURS_CHAT_ROOM: '/Chat/Rooms',
  GET_GROUP_CHAT_DETAIL: '/groups-chat/{roomJid}',
  POST_JOIN_GROUP_SUCCESS: '/groups-chat/{roomJid}/join',
  POST_LEAVE_GROUP_SUCCESS: '/groups-chat/{roomJid}/leave',
  GET_PRIVATE_GROUP_CHAT: '/groups-chat/{roomJid}',
  DELETE_LIST_GROUP_CONVERSATION: '/groups-chat/messages',
  POST_ACCEPT_RULES: '/groups-chat/{roomJid}/rules/accept',

  GET_GROUP_CAN_BE_INVITE: '/groups-chat/invite',
  GROUP_CHAT_INVITE_MEMBER: '/groups-chat/{roomJid}/member/{userId}/invite',

  SERVER_TIME: '/server/time',

  // USER MENU SETTING FOR REACT NATIVE
  // URL_DATE_FINDER: '/Mobile/DateFinder?blnk=hide',
  // URL_TRAVEL_PLAN: '/Mobile/MemberProfile/TravelPlan.aspx?blnk=hide',
  // URL_FORUM: '/Mobile/Forum/Default.aspx?blnk=hide',
  // URL_EVENT: '/Mobile/Event/Default.aspx?blnk=hide',
  // URL_COMMUNITY: '/Mobile/Community/Default.aspx?blnk=hide',
  // URL_CHAT: '/Mobile/Chat/?blnk=hide',
  URL_DATE_FINDER: '/Mobile/response/redir.aspx?token={Token}&dest=DateFinder&platform=Mobile',
  URL_TRAVEL_PLAN: '/Mobile/response/redir.aspx?token={Token}&dest=Travel&platform=Mobile',
  URL_FORUM: '/Mobile/response/redir.aspx?token={Token}&dest=Forum&platform=Mobile',
  URL_EVENT: '/Mobile/response/redir.aspx?token={Token}&dest=Event&platform=Mobile',
  URL_GROUP: '/Mobile/response/redir.aspx?token={Token}&dest=Group&platform=Mobile',
  URL_COMMUNITY: '/Mobile/response/redir.aspx?token={Token}&dest=Community&platform=Mobile',
  URL_CHAT: '/Mobile/response/redir.aspx?token={Token}&dest=Chat&platform=Mobile',
  URL_VERIFY_YOUR_PROFILE: '/Mobile/response/redir.aspx?token={Token}&dest=Verification&platform=Mobile',
  // Mobile app external Link
  URL_DATE_FINDER_MOBILE_APP: '/Mobile/response/redir.aspx?token={Token}&dest=DateFinder&platform=MobileApp',
  URL_TRAVEL_PLAN_MOBILE_APP: '/Mobile/response/redir.aspx?token={Token}&dest=Travel&platform=MobileApp',
  URL_FORUM_MOBILE_APP: '/Mobile/response/redir.aspx?token={Token}&dest=Forum&platform=MobileApp',
  URL_EVENT_MOBILE_APP: '/Mobile/response/redir.aspx?token={Token}&dest=Event&platform=MobileApp',
  URL_GROUP_MOBILE_APP: '/Mobile/response/redir.aspx?token={Token}&dest=Group&platform=MobileApp',
  URL_COMMUNITY_MOBILE_APP: '/Mobile/response/redir.aspx?token={Token}&dest=Community&platform=MobileApp',
  URL_CHAT_MOBILE_APP: '/Mobile/response/redir.aspx?token={Token}&dest=Chat&platform=MobileApp',
  URL_FEED_BACKS_MOBILE_APP: '/Mobile/response/redir.aspx?token={Token}&dest=Feedback&platform=MobileApp',
  // Desktop external Link
  URL_DATE_FINDER_DESKTOP: '/Mobile/response/redir.aspx?token={Token}&dest=DateFinder&platform=Desktop',
  URL_TRAVEL_PLAN_DESKTOP: '/Mobile/response/redir.aspx?token={Token}&dest=Travel&platform=Desktop',
  URL_FORUM_DESKTOP: '/Mobile/response/redir.aspx?token={Token}&dest=Forum&platform=Desktop',
  URL_EVENT_DESKTOP: '/Mobile/response/redir.aspx?token={Token}&dest=Event&platform=Desktop',
  // URL_AMATEURS_DESKTOP: '/Mobile/response/redir.aspx?token={Token}&dest=Amateurs&platform=Desktop', OLD
  URL_AMATEURS_DESKTOP: '/AmPics', // New
  URL_COMMUNITY_DESKTOP: '/Mobile/response/redir.aspx?token={Token}&dest=Community&platform=Desktop',
  URL_HOW_TO_NAIL: '/Mobile/response/redir.aspx?token={Token}&dest=Article&platform=Desktop&id=1462',
  URL_HOW_TO_KISS: '/Mobile/response/redir.aspx?token={Token}&dest=Article&platform=Desktop&id=1460',
  URL_HOW_TO_BE: '/Mobile/response/redir.aspx?token={Token}&dest=Article&platform=Desktop&id=1287',
  URL_FEED_BACKS_DESKTOP: '/Mobile/response/redir.aspx?token={Token}&dest=Feedback&platform=Desktop',
  URL_FEED_BACKS_MOBILE: '/Mobile/response/redir.aspx?token={Token}&dest=Feedback&platform=Mobile',

  // USER MENU OPTION MODAL FOR REACT NATIVE
  // URL_ACCOUNT_SETTING: '/Mobile/MemberProfile/MyAccount.aspx?blink=hide#p=accountsettings',
  // URL_PRIVACY_SETTING: '/Mobile/MemberProfile/PrivacySettings.aspx?blink=hide',
  // URL_NOTIFICATION_SETTING: '/Mobile/MemberProfile/NotificationSetting.aspx?blink=hide',
  // URL_SUBSCRIPTIONS: '/Mobile/MemberProfile/SubscriptionRenewal.aspx?blink=hide',
  // URL_HELP_SUPPORT: '/Mobile/MemberProfile/MyAccount.aspx?blink=hide#p=myaccount',
  URL_SUBSCRIPTION_FAQ: 'https://help.redhotpie.com/hc/en-us/categories/360001921073-Billing-and-Upgrades-',
  URL_CONVERSATION_FAQ: 'https://help.redhotpie.com/hc/en-us/categories/360001921053-Messenger-and-Conversations',
  URL_ACCOUNT_SETTING: '/Mobile/response/redir.aspx?token={Token}&dest=AccountSetting&platform=Mobile',
  URL_PRIVACY_SETTING: '/Mobile/response/redir.aspx?token={Token}&dest=PrivacySetting&platform=Mobile',
  URL_NOTIFICATION_SETTING: '/Mobile/response/redir.aspx?token={Token}&dest=NotificationSetting&platform=Mobile',
  URL_SUBSCRIPTIONS: '/Mobile/response/redir.aspx?token={Token}&dest=Subscription&platform=Mobile',
  URL_HELP_SUPPORT: '/Mobile/response/redir.aspx?token={Token}&dest=HelpSupport&platform=Mobile',
  URL_MANAGE_PHOTOS: '/Mobile/response/redir.aspx?token={Token}&dest=ManagePhotos&platform=Mobile',
  URL_EDIT_PROFILE: '/Mobile/response/redir.aspx?token={Token}&dest=EditProfile&platform=Mobile',
  // URL_AMATEURS_PICS_SETTING: '/Mobile/response/redir.aspx?token={Token}&dest=Amateurs&platform=Mobile', OLD
  URL_AMATEURS_PICS_SETTING: '/AmPics', // New
  URL_APPLE_SUBSCRIPTION: 'https://apps.apple.com/account/subscriptions',
  // Mobile app external Link
  URL_ACCOUNT_SETTING_MOBILE_APP: '/Mobile/response/redir.aspx?token={Token}&dest=AccountSetting&platform=MobileApp',
  URL_PRIVACY_SETTING_MOBILE_APP: '/Mobile/response/redir.aspx?token={Token}&dest=PrivacySetting&platform=MobileApp',
  URL_NOTIFICATION_SETTING_MOBILE_APP: '/Mobile/response/redir.aspx?token={Token}&dest=NotificationSetting&platform=MobileApp',
  URL_SUBSCRIPTIONS_MOBILE_APP: '/rjsapp/authorize/subscription?token={Token}',
  URL_HELP_SUPPORT_MOBILE_APP: '/Mobile/response/redir.aspx?token={Token}&dest=HelpSupport&platform=MobileApp',
  URL_MANAGE_PHOTOS_MOBILE_APP: '/Mobile/response/redir.aspx?token={Token}&dest=ManagePhotos&platform=MobileApp',
  URL_EDIT_PROFILE_MOBILE_APP: '/Mobile/response/redir.aspx?token={Token}&dest=EditProfile&platform=MobileApp',
  URL_MYLIST: '/Mobile/response/redir.aspx?token={Token}&dest=Lists&platform=Mobile',
  URL_MYLIST_MOBILE_APP: '/Mobile/response/redir.aspx?token={Token}&dest=Lists&platform=MobileApp',
  URL_AMATEURS_PICS_SETTING_MOBILE_APP: '/Mobile/response/redir.aspx?token={Token}&dest=Amateurs&platform=MobileApp',
  // Desktop external Link
  URL_SUBSCRIPTIONS_DESKTOP: '/Mobile/response/redir.aspx?token={Token}&dest=Subscription&platform=Desktop',
  URL_HELP_SUPPORT_DESKTOP: '/Mobile/response/redir.aspx?token={Token}&dest=HelpSupport&platform=Desktop',
  URL_TESTIMONIALS_DESKTOP: '/Mobile/response/redir.aspx?token={Token}&dest=Testimonials&platform=Desktop',
  URL_ON_THE_GROUND_GALLERY_DESKTOP: '/Mobile/response/redir.aspx?token={Token}&dest=OnTheGroundGallery&platform=Desktop',
  URL_SEX_SECRET_DESKTOP: '/Mobile/response/redir.aspx?token={Token}&dest=SexSecret&platform=Desktop',
  URL_COMPETITIONS_DESKTOP: '/Mobile/response/redir.aspx?token={Token}&dest=Competitions&platform=Desktop',
  URL_POLLS_DESKTOP: '/Mobile/response/redir.aspx?token={Token}&dest=Polls&platform=Desktop',
  // HOME SCREEN
  GET_USER_PAGE_HOME: '/User/ActivitySummary',
  GET_USER_PAGE_HOME_WITH_PINNED_CONTENT: '/User/Activity',
  GET_PAGE_HOME: '/Mobile/response/redir.aspx?token={Token}&dest={Dest}&id={ItemId}&platform={Platform}',
  GET_PAGE_HOME_FOR_VIEW_ALL: '/Mobile/response/redir.aspx?token={Token}&dest={Dest}&platform={Platform}',
  GET_DATE_FINDER_COUNT: '/User/DateFinder/Count',
  GET_ACTIVE_USERS_COUNT: '/User/Active/Count',
  GET_USER_ACTIVE: '/Profile/Search/Active',
  GET_PROSPECTS_SUMMARY_COUNT: '/User/Prospects/CountSummary',
  GET_CURRENT_COMPETITIONS: '/Competitions/',
  GET_RECENT: '/Profile/Search/Recent',
  // MobileApp external link
  GET_PAGE_HOME_MOBILE_APP: '/Mobile/response/redir.aspx?token={Token}&dest={Dest}&id={ItemId}&platform=MobileApp',

  GET_ACTIVITYSUMMARY_USERS: 'User/ActivitySummary/Users',

  // LIVESTREAM
  GET_LIST_LIVE_STREAMS: '/v1/livestream',
  GET_LIST_PUBLIC_LIVE_STREAMS: '/v1/livestream/public',
  // GET_LIST_LIVE_STREAMS_IN_ROOM: '/v2/broadcasts/list/:offset/:size',
  GET_LIST_LIVE_STREAMS_IN_ROOM: '/v1/livestream/room/{roomId}',
  GET_STREAM_DETAIL: '/api/v1/applications/live/streams/{streamId}?accessToken=redhotpie',
  CREATE_LIVE_STREAM: '/v1/livestream/room/{roomId}',
  WATCH_LIVE_STREAM: '/v1/livestream/{streamId}/view',
  GET_LIST_VIEWER_LIVE_STREAM: '/v1/livestream/{streamId}',
  DELETE_LIVE_STREAM: '/v1/livestream/{streamId}',
  UPLOAD_THUMBNAIL_IMAGE_LIVESTREAM: '/User/Photo',
  UPLOAD_THUMBNAIL_URL: '/v1/livestream/{streamId}',
  CREATE_PUBLIC_LIVE_STREAM: '/v1/livestream',
  CLEAN_UP_LIVE_STREAM: '/v1/livestream/cleanup/room/{roomId}',
  // NOTIFICATION SCREEN
  GET_USER_EVENT_INTEREST: '/User/Event/Interests',
  GET_EVENT_SUGGESTED_MEMBERS: '/Event/{EventID}/SuggestedUsers',
  GET_USER_CLUB_EVENT_SUGGESTED_MEMBERS: '/User/Club/Event/{EventID}/SuggestedUsers',

  GET_USER_ALERT: '/User/Alert',
  GET_USER_ALERT_NOTIFICATION: '/User/AlertNotification',
  GET_USER_VALIDATION_NOTIFICATION: '/User/Validations',
  GET_USER_PHOTO_LIKES_NOTIFICATION: '/User/Photo/Likes',
  GET_USER_FRIEND_NOTIFICATION: '/User/Friends',
  GET_USER_DATEFINDER_NOTIFICATION: '/User/DateFinderDateInterests',
  PATCH_ACTION_NOTIFICATION: '/User/{Entity}/{ID}/{Action}',
  URL_ALERT_NOTIFICATION: '/Mobile/response/redir.aspx?token={Token}&dest={Destination}&id={ItemID}&platform=Mobile',
  URL_ALERT_TICKET_DESKTOP: '/support/TicketList.aspx',
  URL_ALERT_PHOTO_DESKTOP: '/MemberPhoto',
  URL_ALERT_PROFILE_DESKTOP: '/MemberProfile/MemberEdit.aspx',
  URL_FRIEND_NOTIFICATION_MORE: '/Friends',
  URL_DATE_FINDER_INTERESTS: '/DateFinder/Default.aspx?show=myDates',
  URL_ACCOUNT_PROFILE: '/MemberProfile/ProfileMenu.aspx',
  URL_LISTS: '/Lists',
  // Mobile app external link
  URL_ALERT_NOTIFICATION_MOBILE_APP: '/Mobile/response/redir.aspx?token={Token}&dest={Destination}&id={ItemID}&platform=MobileApp',
  GET_USER_DATEFINDER_INTEREST: '/User/DateFinder/{ID}/Interest',

  LIVESTREAM_VIEW_URL_DEV: '/rjsapp/portable-subscriber-mobile/groupchat?streamsName={streamName}&userId={userId}&token={token}',
  LIVESTREAM_VIEW_URL_PROD: '/rjsapp/portableGroupChat/v1/index.html?streamsName={streamName}&userId={userId}&token={token}',
  LIVESTREAM_WEB_URL:
    '/rjsapp/chat-rooms?roomName={roomName}&roomId={roomId}&RHPToken={rhpToken}&MessengerToken={messengerToken}&origin=Mobile',

  GET_GROUP_CHAT_COUNT: '/groups-chat/groups/{groupId}/count',
  GET_GROUP_CHATS: '/groups-chat/groups/{groupId}',
  PATCH_UPDATE_GROUP_CHAT: '/groups-chat/private/{roomJid}',
  POST_LEAVE_MEMBER_GROUP_CHAT: '/groups-chat/{roomJid}/member/{userId}/leave',
  POST_ADD_MEMBER_GROUP_CHAT: '/groups-chat/{roomJid}/member/{userId}/join',
  POST_END_GROUP_CHAT: '/groups-chat/{roomJid}/end',
  DELETE_PARENT_OWNED_COMMENT: '/Comment/{Id}/ParentOwned',
  DELETE_THEAD_MESSAGE: '/Forum/Message/{Id}/Delete',
  POST_CREATE_EVENT_VIDEO: '/User/Event/Video',
  // MEMBER_TYPE_PLURAL FILTER COMMON
  GET_MEMBER_TYPE_PLURAL: '/Lookup/membertypeplural?LookupType=Search',
  // EVENT SCREEN
  GET_EVENT_SEARCH: '/Event/Search',
  GET_USER_EVENT: '/User/Event',
  GET_MY_USER_EVENT: '/User/Event/{EventID}',
  GET_USER_CLUB_EVENT: '/User/Club/Event/{EventID}',
  GET_USER_INTEREST_EVENT: '/User/Event/{EventID}/Interest',
  POST_USER_INTEREST_EVENT: '/User/Event/{EventID}/Interest',
  GET_EVENT_INTEREST: '/Event/{ID}/Interest',
  GET_EVENT_INTEREST_LIST: '/Event/{ID}/Interest/List',
  DELETE_EVENT_INTEREST: '/Event/{ID}/Interest/Remove',
  GET_EVENT_DETAIL: '/Event/{ID}',
  GET_EVENT_COMMENT: '/Event/{ID}/Comment',
  GET_COMMENTS_REPLIES: '/Comment/Replies',
  GET_COMMENTS_REPLY_FULL: '/Comment/{CommentParentID}/Replies',
  GET_EVENT_CATEGORY: '/Lookup/EventCategory',
  GET_CLUB_CATEGORY: '/Lookup/ClubsCategory',
  GET_EVENT_POPULAR_COUNT: '/Event/Count',
  GET_CLUB_COUNT: '/Club/Count',
  POST_CREATE_COMMENT_LIKE: '/Comment/{ID}/Like',
  PATCH_COMMENT_LIKE: '/Comment/{ID}/Like',
  GET_TIMEZONE: '/Lookup/timezones',
  GET_EVENT_BANNER: '/User/Event/GenericBanners',
  POST_UPLOAD_BANNER: '/User/Event/Banner',
  PATCH_UPDATE_USER_EVENT_TICKET: '/Event/{EventID}/Interest/{InterestID}/Ticket',
  PATCH_UPDATE_USER_EVENT_GROUP_CHAT: '/Event/{EventID}/Interest/{InterestID}/GroupChat',
  DELETE_ALL_USER_EVENT_GROUP_CHAT: '/Event/{EventID}/Interest/GroupChat',
  DELETE_EVENT_INTEREST_BY_OWNER: '/Event/{EventID}/Interest/{InterestID}',
  POST_CREATE_GROUP_CHAT: '/groups-chat/private',
  GET_SEARCH_GROUP_CHAT: '/groups-chat/search?refObjId={refObjId}&refObjType={refObjType}',

  // EVENT CLUB & ORGANISER
  GET_CLUB_SEARCH: '/Club/Search',
  GET_DETAIL_CLUB: '/Club/{ID}',
  GET_PHOTO_DETAIL_CLUB: '/Club/{ID}/Photo',

  GET_EVENT_CLUB: '/Club/{ID}/Event',
  POST_CREATE_EVENT: '/User/Event',
  POST_CREATE_USER_CLUB_EVENT: '/User/Club/{ClubID}/Event',
  PATCH_DELETE_MY_EVENT: '/User/Event/',
  PATCH_DELETE_USER_CLUB_EVENT: '/User/Club/{ClubID}/Event',
  POST_CREATE_EVENT_INTEREST: '/Event/{ID}/Interest/Register',
  CREATE_EVENT_INTEREST_INVITE: '/Event/{ID}/Interest/Invite',
  POST_CREATE_EVENT_COMMENT: '/Event/{ID}/Comment',
  DELETE_COMMENT: '/Comment/{ID}',
  PATCH_DELETE_EVENT_INTEREST: '/Event/{ID}/Interest/Remove',
  PATCH_DELETE_USER_EVENT_INTEREST: '/User/Event/{EventID}/Interest',
  GET_COMMENTS_LIKE: '/Comment/{ID}/Like',
  // Location
  RHP_GET_AUTOCOMPLETE_LOCATION: '/Location/Search',
  RHP_GET_LOCATION: '/Location/Country',

  ADD_OR_REMOVE_SINGLE_CONVERSATION_TO_MULTIPLE_FOLDER: '/conversations/{conversationId}/folders',
  GET_FOLDERS: '/folders',
  CREATE_FOLDER: '/folders',
  UPDATE_FOLDER: '/folders/{id}',
  DELETE_FOLDER: '/folders/{id}',

  ADD_CONVERSATION_TO_FOLDER: '/conversations/{conversationId}/folder/{folderId}',
  REMOVE_CONVERSATION_FROM_FOLDER: '/conversations/{conversationId}/folder/{folderId}',

  LINK_MANAGE_PHOTO: 'https://redhotpie.com.au/Mobile/response/redir.aspx?token=',
  EDIT_PROFILE: '/Mobile/response/redir.aspx?token={Token}&dest={Dest}',
  LOOK_UP_EDIT_PROFILE: '/Lookup/EditProfile/',

  // Pay memberships
  MOBILE_PAY_MEMBER: '/Mobile/Upgrade/DefaultNew.aspx',
  DESKTOP_PAY_MEMBER: '/PayMemberships/upgrademembership.aspx',
  // IAP
  GET_PRODUCT_APPLE: '/Product/Apple?Version=2',
  GET_PRODUCT_APPLE_MEMBER_SHIP: '/Product/Apple/Memberships',
  GET_PRODUCT_EXTRAS: '/Product/Apple/Addons',
  RHP_VALIDATE_PRODUCT_APPLE: '/Product/Validate/Apple',
  GET_CONVERSATION_CREDITS_PRODUCT: '/Product/Apple/ConversationCredits',
  GET_CONVERSATION_CREDITS_PRODUCT_GOOGLE: '/Product/Google/ConversationCredits',

  //
  GET_PRODUCT_GOOGLE: '/Product/Google',
  RHP_VALIDATE_PRODUCT_GOOGLE: '/Product/Validate/Google',
  GET_PAYMENT_OPTIONS_METHOD: '/Product/PaymentOptions/Google',
  GET_APPLE_PRODUCT_COINS: '/Product/Apple/Coins',
  //= ====
  UPGRADE_CHANNEL_ID_URBAN_AIRSHIP: '/User/Account/Settings/Push',
  DELETE_CHANNEL_ID_URBAN_AIRSHIP: '/User/Account/Settings/Push/Delete',

  // Rating
  CREATE_USER_APP_RATING: '/User/AppRating',
  URL_PRODUCT_REVIEW: 'https://www.productreview.com.au/listings/redhotpie/write-review',

  // Notification Summary count
  GET_NOTIFICATION_COUNT_FOR_NEW_FEED: '/User/Notification/Total',
  GET_NOTIFICATION_COUNT_FOR_PROSPECT: '/User/Prospects/Count',
  NOTIFICATION_GROUP_MESSAGE: '/User/Notification/GroupMessage',

  // EDIT PROFILE
  GET_USER_PHOTO_GALLERY: '/User/Photo/Gallery',
  USER_PHOTO: '/User/Photo',
  USER_PROFILE: '/User/Profile',
  // General info
  LOOK_UP_MARITAL_STATUS: '/Lookup/maritalstatus?LookupType=Registration',
  LOOK_UP_SEXUAL: '/Lookup/Sexual?LookupType=Registration',
  LOOK_UP_RACE: '/Lookup/race?LookupType=Registration',
  LOOK_UP_PERSONALITY: '/Lookup/personality?LookupType=Registration',
  LOOK_UP_MY_LOOKS: '/Lookup/mylooks?LookupType=Registration',
  LOOK_UP_BODY_TYPE: '/Lookup/bodytype?LookupType=Registration',
  LOOK_UP_HEIGHT: '/Lookup/height?LookupType=Registration',
  LOOK_UP_EYE_COLOUR: '/Lookup/eyecolour?LookupType=Registration',
  LOOK_UP_HAIR_COLOUR: '/Lookup/haircolour?LookupType=Registration',
  LOOK_UP_HAIR_LENGTH: '/Lookup/hairlength?LookupType=Registration',
  LOOK_UP_DRINKING: '/lookup/drinking?LookupType=Registration',
  LOOK_UP_SMOKING: '/Lookup/smoking?LookupType=Registration',
  // Intimate Info
  LOOK_UP_SAFE_SEX: '/Lookup/safesex?LookupType=Registration',
  LOOK_UP_BODY_HAIR: '/Lookup/bodyhair?LookupType=Registration',
  LOOK_UP_PUBLIC_HAIR: '/Lookup/pubichair?LookupType=Registration',
  LOOK_UP_ENDOWMENT_LENGTH: '/Lookup/EndowmentLength?LookupType=Registration',
  LOOK_UP_ENDOWMENT_THICK_NESS: '/Lookup/EndowmentThickness?LookupType=Registration',
  LOOK_UP_INTIMATE_PIERCING: '/Lookup/IntimatePiercing?LookupType=Registration',
  LOOK_UP_SEXUAL_PERSONALITY: '/Lookup/SexualPersonality?LookupType=Registration',
  // Participation level
  LOOK_UP_PARTICIPATION_LEVEL: '/Lookup/participationlevel',
  // Interest

  LOOK_UP_GENERAL_INTEREST: '/Lookup/generalinterest?LookupType=Registration',
  LOOK_UP_FETISH_INTEREST: '/Lookup/FetishInterest?LookupType=Registration',
  //
  LOOK_UP_PROFILE_BUILDER_PERSONALITY: '/ProfileBuilder/personality',
  LOOK_UP_PROFILE_BUILDER_LOOKS: '/ProfileBuilder/looks',
  LOOK_UP_PROFILE_BUILDER_INTEREST: '/ProfileBuilder/interests',
  LOOK_UP_PROFILE_BUILDER_SEEKING: '/ProfileBuilder/Seeking',
  DELETE_ALL_REJECTED_PHOTOS: '/User/Photo/Rejected',
  //
  URL_VERIFY_PROFILE: '/Mobile/Verification/',
  //
  LOOK_UP_INTENTION: '/Lookup/Intention?LookupType=Registration',
  VERIFICATION_ACCOUNT: '/User/Verification',
  // URL for Header on Login Page
  RHP_MEMBER: '/MemberSearch',
  RHP_CHAT: '/Chat',
  RHP_EVENT: '/Event',
  RHP_TRAVEL_AND_AMATEUR: '/JoinNow/v2/1',
  RHP_ADULT: '/Adult-Forums',
  RHP_COMMUNITY: '/Community',
  RHP_SIGN_UP: '/JoinNow/v2/1',
  // URL for Footer on Login Page
  RHP_FACEBOOK: 'https://www.facebook.com/redhotpieapp/',
  RHP_INSTAGRAM: 'https://www.instagram.com/redhotpieapp',
  RHP_TWITTER: 'https://twitter.com/redhotpie',
  RHP_YOUTUBE: 'https://www.youtube.com/channel/UCNlnowKVYWLVzQuXQ5GBXDw',
  RHP_APP_STORE: 'https://apps.apple.com/app/rhpmobile/id405146852',
  RHP_PLAY_STORE: 'https://play.google.com/store/apps/details?id=com.digitalquarter.redhotpie.app',
  LINK_DOWNLOAD_ANDROID_APP: 'https://redhotpie.com.au/app/android',
  RHP_CONTACT: '/Support/SubmitTicket.aspx',
  RHP_RSS: '/Feeder/rss.aspx',
  // Update user location
  USER_ONLINE: '/User/Online',
  MAKE_PHOTO_MAIN_PHOTO: '/User/Photo/{photoId}/MainPhoto',
  // Account Setting
  UPDATE_USER_PHONE: '/User/Phone',
  VERIFY_USER_PHONE: '/User/Phone/Verification',
  VERIFY_RESEND_USER_PHONE: '/User/Phone/Verification/ResendCode',
  VALIDATE_PHONE_NUMBER: '/User/Phone/Validate',
  GET_USER_PHONE: '/User/Phone',
  UPDATE_USER_EMAIL: '/User/Account/EmailAddress',
  UPDATE_USER_PASSWORD: '/User/Account/Password',
  UPDATE_USER_USERNAME: '/User/Account/Username',
  POST_PAUSE_ACCOUNT: '/User/Account/Pause',
  POST_UNPAUSE_ACCOUNT: '/User/Account/Unpause',
  DELETE_ACCOUNT: '/User/Account',
  CONNECT_DELETE_ACCOUNT_APPLE: '/User/Account/Apple',
  CONNECT_DELETE_ACCOUNT_FACEBOOK: '/User/Account/Facebook',
  CONNECT_DELETE_ACCOUNT_GOOGLE: '/User/Account/Google',
  CREATE_USER_PASSWORD: '/User/Account/Password',
  // My List
  GET_VALIDATIONS_LIST: '/User/Validations',
  GET_BLOCK_LIST: '/User/BlockList',
  GET_USER_PHOTO_GALLERY_ACCESS_LIST: '/User/Photo/Gallery/AccessList',
  GET_USER_IGNORE: '/User/Ignore',
  RHP_GALLERY: '/rjsapp/authorize/image-gallery?token={Token}&id={id}&index={index}',
  RHP_RETRICTED_MEDIA: '/rjsapp/authorize/restricted-media?token={Token}&mediaId={mediaId}',

  // Legal
  TERMS_OF_USE: '/app/Legal/TermsConditions',
  INFO_ABOUT_PUBLIC_PHOTO: '/app/UploadPhotoInfo',
  PRIVACY_POLICY: '/app/Legal/PrivacyPolicy',
  TERMS_AND_CONDITION_ANDROID_STORE: 'https://frootdigital.com/terms-conditions/',
  PRIVACY_POLICY_ANDROID_STORE: 'https://frootdigital.com/privacy-policy/',
  DATING_SAFETY: '/app/Legal/DatingSafety',
  RHP_PLEDGE: '/app/Legal/PiePledge',
  COMMUNITY_GUIDELINES: '/app/Legal/CommunityGuidelines',
  PHOTO_GUIDELINES: '/app/legal/PhotoGuidelines',
  // Upgrade member
  UPGRADE_MEMBERSHIP: '/Product/Membership',
  UPGRADE_PURCHASE: '/User/Purchase',
  GET_INFO_PRODUCT: '/User/Purchase/DecodePurchase',
  GET_ACTIVE_MEMBERSHIP: '/User/Purchase/Active',
  GET_CREDIT_MEMBERSHIP: '/User/Purchase/Credits',
  // Retain my status
  DISABLE_RECERRING: '/User/Account/Recurring/Disable',
  ENABLE_RECERRING: '/User/Account/Recurring/Enable',
  // get Credit card
  GET_CREDIT_CARD: '/User/CreditCard',
  DELETE_CREDIT_CARD: '/User/CreditCard',
  // Link guide line edit profile desktop
  LINK_GUIDE_EDIT_RPOFILE: '/app/legal/PhotoGuidelines',
  // DateFinder
  POST_FILTER_DATE_FINDER: '/DateFinder/',
  GET_LIST_DATE_FINDER: '/DateFinder/{ID}',
  POST_CREATE_DATE_FINDER: '/User/DateFinder',
  EDIT_DATE_FINDER: '/User/DateFinder/{ID}',
  GET_MY_DATE_FINDER: '/User/DateFinder',
  GET_MY_DATE_FINDER_INTERESTS: '/User/DateFinder/{ID}/Interest',
  PATCH_DATE_FINDER_INTEREST: '/User/DateFinder/{ID}/Interest',
  DELETE_DATE_FINDER: '/User/DateFinder',
  DELETE_DATE_FINDER_ALL_INTERESTS: '/User/DateFinder/{ID}/DateInterests',
  // TravelPlan
  GET_MY_TRAVEL_PLAN: '/User/Travel',
  CREATE_TRAVEL_PLAN: '/User/Travel',
  UPDATE_TRAVEL_PLAN: '/User/Travel/{ID}',
  DELETE_TRAVEL_PLAN: '/User/Travel/',
  USER_TRAVEL: '/UserTravel/',
  USER_TRAVEL_SEARCH: '/UserTravel/Search',

  // FORUM\ (https://trello.com/c/axhuTfF6/545-forums-api)
  // == DATA LIST
  // === https://tstsrvs.redhotpie.com.au/json/metadata?op=GetForums
  GET_TOP_LEVEL_FORUM_LIST: '/Forum',
  // === https://tstsrvs.redhotpie.com.au/json/metadata?op=GetSubForums
  GET_SUB_FORUM_LIST: '/Forum/{Id}/SubForum',

  // == FORUM SUMMARIES
  // === Get top level summaries (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetForumSummary)
  GET_TOP_LEVEL_FORUM_SUMMARIES: '/Forum/Summary', // GET Board List
  // === Get sub-forum summaries (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetSubForumSummary)
  GET_SUB_FORUM_SUMMARIES: '/Forum/Summary/{Id}/SubForum', // Get List of Categories (Board Id)

  // == THREAD LIST
  // ==== Get active / trending forum topics (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetForumTopicActive)
  GET_FORUM_TOPIC_ACTIVE: '/Forum/Active', // Forum trending
  GET_FORUM_TOPIC_LIST_ACTIVE: '/Forum/Topic/Active', // Forum trending
  // ==== Get recent / newest forum topics (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetForumTopicRecent)
  GET_FORUM_TOPIC_NEWEST: '/Forum/Recent', // Forum newest
  GET_FORUM_TOPIC_LIST_NEWEST: '/Forum/Topic/Recent', // Forum newest

  // == TOPIC/THREAD LISTS
  // ==== Get forum thread, will return a thread consist of forum topic and its replies (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetForumThread)
  GET_FORUM_THREAD: '/Forum/Topic/{Id}/Thread', // Get forum topic details
  // === Get thread list of a forum (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetForumTopics)
  GET_FORUM_TOPICS: '/Forum/{Id}/Topics', // Get Topic List of any forums
  GET_FORUM_TOPICS_LIST: '/Forum/{Id}/TopicList', // Get Topic List of any forums
  // === https://tstsrvs.redhotpie.com.au/json/metadata?op=CreateForumTopic
  POST_CREATE_FORUMS_TOPIC: '/Forum/{Id}', // Create new topic in board (id => board Id)
  // Create a reply to a forum topic, will return the topic and the created reply when success ('https://tstsrvs.redhotpie.com.au/json/metadata?op=CreateForumMessage')
  POST_CREATE_FORUM_TOPIC_MESSAGE: '/Forum/Topic/{Id}', // Create forum topic message

  // == TOPIC LIKES
  // === Get list of users (ProfileSummaryListItem) who likes a thread (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetForumTopicLikes)
  GET_FORUM_TOPIC_LIKES: '/Forum/Topic/{Id}/Like',
  // === Like a topic, will return ProfileSummaryListItem of a user that like the topic (https://tstsrvs.redhotpie.com.au/json/metadata?op=CreateForumTopicLike)
  POST_CREATE_FORUM_TOPIC_LIKE: '/Forum/Topic/{Id}/Like',
  // === Unlike a topic, will return generic response true when successful(https://tstsrvs.redhotpie.com.au/json/metadata?op=CreateForumTopicUnlike)
  POST_CREATE_FORUM_TOPIC_UN_LIKE: '/Forum/Topic/{Id}/Unlike',

  // == MESSAGE LIKE
  // === Get list of users (ProfileSummaryListItem) who likes a reply (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetForumMessageLikes)
  GET_FORUM_MESSAGE_LIKE: '/Forum/Message/{Id}/Like',
  // === Like a reply, will return ProfileSummaryListItem of a user that like the reply (https://tstsrvs.redhotpie.com.au/json/metadata?op=CreateForumMessageLike)
  POST_CREATE_FORUM_MESSAGE_LIKE: '/Forum/Message/{Id}/Like',
  // === Unlike a reply, will return generic response true when successful (https://tstsrvs.redhotpie.com.au/json/metadata?op=CreateForumMessageUnlike)
  POST_CREATE_FORUM_MESSAGE_UN_LIKE: '/Forum/Message/{Id}/Unlike',

  // FORUM FOLLOWER
  // === Follow a topic, will return generic response true when successful (https://tstsrvs.redhotpie.com.au/json/metadata?op=CreateForumTopicFollower)
  POST_CREATE_TOPIC_FOLLOWING: '/Forum/Topic/{Id}/Follow',
  // === UnFollow a topic, will return generic response true when successful (https://tstsrvs.redhotpie.com.au/json/metadata?op=CreateForumTopicUnFollower)
  POST_CREATE_TOPIC_UN_FOLLOW: '/Forum/Topic/{Id}/UnFollow',

  // USER FORUM
  // === GetForumTopicPosted (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetForumTopicPosted)
  GET_USER_FORUM_POSTED: '/User/Forum', // My topic
  GET_USER_FORUM_POSTED_DESKTOP: '/User/Forum/Topic', // My topic
  // === Get followed forum topics (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetForumTopicFollowed)
  GET_USER_FORUM_TOPIC_FOLLOWED: '/User/Forum/Followed', // Following forum
  GET_USER_FORUM_TOPIC_FOLLOWED_DESKTOP: '/User/Forum/Followed/Topic',
  // FORUM SEARCH
  FORUM_SEARCH_BY_TITLE: '/Forum/Search',
  FORUM_SEARCH_TAG: '/Tag/Search',
  FORUM_SEARCH_RESULT_BY_TAG: '/Forum/Tag/{Id}',
  SEARCH_FORUMS_BY_TAG: '/Forum/Search/Tag/{Id}',
  // REGIONAL
  FORUM_REGIONAL: '/Forum/Regional',
  // FORUM REPLY
  // https://tstsrvs.redhotpie.com.au/json/metadata?op=CreateForumComment
  // Create a comment to a forum message, will return the topic, message, and created comment when success
  POST_CREATE_FORUM_REPLY: '/Forum/Message/{Id}', // create forums message
  // https://tstsrvs.redhotpie.com.au/json/metadata?op=GetForumComments
  GET_FORUM_REPLY: '/Forum/Message/{Id}/Comments',

  // / Upgrade credit card comweb

  UPGRADE_CREDIT_CARD: '/rjsapp/authorize/update-card-detail?token={Token}',
  // Get Popular tag https://tstsrvs.redhotpie.com.au/json/metadata?op=GetForumPopularTags
  GET_POPULAR_TAGS: '/Forum/{Id}/Tags/Popular',
  // Delete Topic https://tstsrvs.redhotpie.com.au/json/metadata?op=DeleteForumTopic
  DELETE_TOPIC: '/User/Forum/Topic/{Id}',
  // https://tstsrvs.redhotpie.com.au/json/metadata?op=DeleteForumMessage
  DELETE_TOPIC_MESSAGE: '/User/Forum/Message/{Id}',
  // HOME STREAM
  // https://tstsrvs.redhotpie.com.au/json/metadata?op=GetUserAnnouncement
  GET_USER_ANNOUNCEMENT_BANNER: '/User/Announcement/Banner',
  // Community (https://trello.com/c/NaHjc0S4/551-community-api)
  //= =============================

  // ARTICLE
  /* Get Articles List  (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetArticles)
                 + Query  Category, Page , Size
             */
  GET_ARTICLES_LIST: '/Article',
  /* Get Article Details  (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetArticle)
                + Query ID
             */
  GET_ARTICLE_DETAILS: '/Article/{ID}',
  GET_ARTICLE_CATEGORIES_COUNT_SUMMARY: '/Article/Category/CountSummary',
  GET_STORY_CATEGORIES_COUNT_SUMMARY: '/Story/Category/Summary',

  /* Article Like
                 - GET Article Like  (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetArticleLikes)
                     + Query ID
                - POST create Article Like  (https://tstsrvs.redhotpie.com.au/json/metadata?op=CreateArticleLike)
                     + Parameters {ID:0}
                - PATCH Delete Article Like  (https://tstsrvs.redhotpie.com.au/json/metadata?op=DeleteArticleLike)
                     + Parameters {ID:0}
             */
  ARTICLE_LIKES: '/Article/{ID}/Like',
  /* Article Comments
                    - GET Article Comments  (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetArticleComments)
                        + Query ID Parameters {ID:0, Size:1, Page:0}
                   - POST create Article Comments  (https://tstsrvs.redhotpie.com.au/json/metadata?op=CreateArticleComment)
                        + Parameters {
                                  ID
                                  CommentParentID
                                  Subject
                                  Message
                               }
                */
  ARTICLE_COMMENTS: '/Article/{ID}/Comment',
  /* Article Competition
               - POST create Competition
                   + Parameters {
                       ID
                       Name
                       Email
                       Address
                       Answer
                       Phone
                   }
             * */
  POST_COMPETITION: '/Competitions/{ID}',
  // STORY

  // /* GET Story Category Count Summary (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetStoryCategoryCountSummary)
  //     GenericCountSummary Parameters:
  // Name form string No
  // */
  // GET_STORY_CATEGORY_COUNT_SUMMARY: '/Story/Category/Summary',
  /* GET Stories List (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetStories)
           POST Create Story (https://tstsrvs.redhotpie.com.au/json/metadata?op=CreateStory)
           StoryPost Parameters:
              Title form string No
              Content form string No
           */
  STORY: '/Story',
  MY_STORY: '/User/Story',
  DELETE_STORY: '/User/Story',
  PATCH_STORY: '/User/Story/{id}',
  GET_STORY_AUTHOR_DETAIL: '/Story/Author/{UserID}',
  /*
   * Story Details
   * Get story details (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetStory)
   *
   * */
  STORY_DETAILS: '/Story/{ID}',
  /* Story Comments
              GET Stories comments (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetStoryComments)
              POST CreateStoryComment (https://tstsrvs.redhotpie.com.au/json/metadata?op=CreateStoryComment)
                 CommentPost Parameters:
                    ID form int No
                    CommentParentID form int No
                    Subject form string No
                    Message form string No
             * */
  STORY_COMMENTS: '/Story/{ID}/Comment',
  /* Story Likes
             * GetStoryLikes (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetStoryLikes)
             * GetStoryLikes Parameters:
             * POST CreateStoryLike (https://tstsrvs.redhotpie.com.au/json/metadata?op=CreateStoryLike)
             * CreateStoryLike Parameters:
                     ID path int No
             * PATCH DeleteStoryLike (https://tstsrvs.redhotpie.com.au/json/metadata?op=DeleteStoryLike)
                     DeleteStoryLike Parameters:
                     ID path int No
             * */
  STORY_LIKE: '/Story/{ID}/Like',
  // ON THE GROUND (OTG)
  /* On the ground list item (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetOnTheGroundListItems)
   * */
  GET_OTG_LIST_ITEM: '/OnTheGround',
  // OTG_VIDEO
  /* GetOnTheGroundVideo(https://tstsrvs.redhotpie.com.au/json/metadata?op=GetOnTheGroundVideo) */
  GET_OTG_VIDEO: '/OnTheGround/Video/{ID}',
  /*
                Get On the Ground Video Like (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetOnTheGroundVideoLikes)
                PATCH DeleteOnTheGroundVideoLike  (https://tstsrvs.redhotpie.com.au/json/metadata?op=DeleteOnTheGroundVideoLike)
                POST CreateOnTheGroundVideoLike (https://tstsrvs.redhotpie.com.au/json/metadata?op=CreateOnTheGroundVideoLike)
             *
             * */
  OTG_VIDEO_LIKE: '/OnTheGround/Video/{ID}/Like',
  /*
                GET On the Ground Video Comment  (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetOnTheGroundVideoComments)
                POST CreateOnTheGroundVideoComment (https://tstsrvs.redhotpie.com.au/json/metadata?op=CreateOnTheGroundVideoComment)
                  +CommentPost Parameters:
                     ID form int No
                     CommentParentID form int No
                     Subject form string No
                     Message form string No
             * */
  OTG_VIDEO_COMMENTS: '/OnTheGround/Video/{ID}/Comment',
  // OTG_PHOTO
  /** GetOnTheGroundGalleryDetail (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetOnTheGroundGallery)  */
  GET_OTG_GALLERY_DETAIL: '/OnTheGround/Gallery/{ID}',
  /* GetOnTheGroundGalleryPhotos (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetOnTheGroundGalleryPhotos) */
  GET_OTG_PHOTOS: '/OnTheGround/Gallery/{ID}/Photo',
  /*
               Get GetOnTheGroundPhotoLikes (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetOnTheGroundPhotoLikes)
               PATCH DeleteOnTheGroundPhotoLike  (https://tstsrvs.redhotpie.com.au/json/metadata?op=DeleteOnTheGroundPhotoLike)
               POST CreateOnTheGroundPhotoLike (https://tstsrvs.redhotpie.com.au/json/metadata?op=CreateOnTheGroundPhotoLike)
            *
            * */
  OTG_PHOTOS_LIKE: '/OnTheGround/Photo/{ID}/Like',
  /*
                GET GetOnTheGroundPhotoComments  (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetOnTheGroundPhotoComments)
                POST CreateOnTheGroundPhotoComment (https://tstsrvs.redhotpie.com.au/json/metadata?op=CreateOnTheGroundPhotoComment)
                  +CommentPost Parameters:
                     ID form int No
                     CommentParentID form int No
                     Subject form string No
                     Message form string No
             * */
  OTG_PHOTOS_COMMENTS: '/OnTheGround/Photo/{ID}/Comment',
  // OTG_GALLERY
  /*
               Get GetOnTheGroundGalleryLikes (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetOnTheGroundGalleryLikes)
               PATCH DeleteOnTheGroundGalleryLike  (https://tstsrvs.redhotpie.com.au/json/metadata?op=DeleteOnTheGroundGalleryLike)
               POST CreateOnTheGroundGalleryLike (https://tstsrvs.redhotpie.com.au/json/metadata?op=CreateOnTheGroundGalleryLike)
            *
            * */
  OTG_GALLERY_LIKE: '/OnTheGround/Gallery/{ID}/Like',
  /*
                GET  GetOnTheGroundGalleryComments (https://tstsrvs.redhotpie.com.au/json/metadata?op=GetOnTheGroundGalleryComments)
                POST CreateOnTheGroundGalleryComment (https://tstsrvs.redhotpie.com.au/json/metadata?op=CreateOnTheGroundGalleryComment)
                  +CommentPost Parameters:
                     ID form int No
                     CommentParentID form int No
                     Subject form string No
                     Message form string No
             * */
  OTG_GALLERY_COMMENTS: '/OnTheGround/Gallery/{ID}/Comment',
  // TESTIMONIAL
  /*
                  GetTestimonials(https://tstsrvs.redhotpie.com.au/json/metadata?op=GetTestimonials)
                  CreateTestimonial(https://tstsrvs.redhotpie.com.au/json/metadata?op=CreateTestimonial)
                     CreateTestimonial Parameters:
                         Message body string No
                         Type body TestimonialType? No
             */
  TESTIMONIAL: '/Testimonial',
  CATEGORY_ARTICLE_COUNT_SUMMARY: '/Article/Category/CountSummary',
  CATEGORY_STORIES_COUNT_SUMMARY: '/Story/Category/Summary',

  /*
               ASK SAMANTHA
              */
  GET_Q_AND_A_LIST: '/QandA',
  GET_Q_AND_A_ITEM: '/QandA/{ID}',
  GET_Q_AND_A_LIKES: '/QandA/{ID}/Like',
  GET_Q_AND_A_COMMENTS: '/QandA/{ID}/Comment',
  GET_Q_AND_A_COUNT_SUMMARY: '/QandA/Category/CountSummary',
  CREATE_Q_AND_A: '/QandA',
  CREATE_Q_AND_A_COMMENT: '/QandA/{ID}/Comment',
  CREATE_Q_AND_A_LIKE: '/QandA/{ID}/Like',
  DELETE_Q_AND_A_LIKE: '/QandA/{ID}/Like',

  //
  SEND_NOTIFICATION: '/send/notification/me',

  LINK_BROWSER_FIREFOX: 'https://www.mozilla.org/',
  LINK_BROWSER_EDGE: 'https://www.microsoft.com/en-us/edge',
  LINK_BROWSER_CHROME: 'https://www.google.com/chrome/',
  LINK_BROWSER_SAFARI: 'https://support.apple.com/downloads/safari',
  GET_APP_VERSION: '/version',
  MOBILE_SITE: 'http://redhotpie.com.au/',
  ANDROID_APP_MARKET: 'market://details?id={bundleID}',
  APPLE_APP_MARKET: 'itms-apps://itunes.apple.com/us/app/apple-store/{bundleID}?mt=8',

  GET_ACTIVE_USER_STATE_COUNT: '/User/Active/StateCount',

  // SUPPORT TICKET
  GET_LIST_CATEGORY_CONTACT_SUPPORT: '/Lookup/SupportTicketCategory',
  CREATE_SUPPORT_TICKET: '/Support',
  ADD_SUPPORT_TICKET_CONTACT: '/Support/Contact',
  ADD_SUPPORT_TICKET_ATTACHMENTS: '/Support/Attachments',
  GET_SUPPORT_TICKET: '/Support?page={pageNumber}&size={pageSize}&categoryID={categoryID}',
  GET_SUPPORT_TICKET_DETAIL: '/Support/{TicketRef}',
  UPDATE_SUPPORT_TICKET_STATUS: '/Support/{TicketRef}',
  GET_SUPPORT_TICKET_NEW_COUNT: '/Support/NewCount',

  // FAQ
  FAQ: 'https://help.redhotpie.com/hc/en-us',

  PATCH_USER_VCARD: '/users/vCard',
  // PUSH NOTIFICATION SETTINGS
  PUSH_NOTIFICATION_SETTINGS: '/User/Account/Settings/PushNotification',
  // https://tstsrvs.redhotpie.com.au/json/metadata?op=PatchPushNotificationSettings
  EMAIL_NOTIFICATION_SETTINGS: '/User/Account/Settings/EmailNotification',
  // https://tstsrvs.redhotpie.com.au/json/metadata?op=PatchEmailNotificationSettings
  APPLE_AUTHORISE: '/Apple/Authorise',
  ABOUT_RHP: '/Legal/About',

  // GET ABOUT RHP
  GET_ABOUT_RHP: '/About',

  GET_SEARCH_FRIEND_ONLINE: '/Profile/Search/Friends',
  GET_SEARCH_FAVORITE_ONLINE: '/Profile/Search/Favourites',

  // URBAN_AIRSHIP_SDK_URL: "https://aswpsdkeu.com/notify/v1/ua-sdk.min.js" // NOTE: there is 2 server: EU and US
  URBAN_AIRSHIP_SDK_URL: 'https://aswpsdkus.com/notify/v1/ua-sdk.min.js', // NOTE: there is 2 server: EU and US,
  // PUSHY
  PUSHY_REGISTER_TOKEN: '/User/Pushy',
  URL_FAQ_MESSENGER: 'https://help.redhotpie.com/hc/en-us/categories/360001921053-Messenger-and-Conversations',
  GET_USER_SHARED_PHOTOS: '/User/Photo/Shared',
  GET_USER_SHARED_MEDIA: '/User/Media/Shared',
  POST_CREATE_USER_VIDEO: '/User/Video',
  POST_CREATE_USER_AUDIO: '/FileUpload/Audio',
  DELETE_USER_VIDEOS: '/User/Video',
  GET_PROFILE_VIDEO: '/Profile/{Id}/Video/{VideoID}',
  GET_PROFILE_AUDIO: '/Profile/{Id}/AudioMsg/{FileName}',

  // RHP Store
  GET_STORE_PRODUCTS: '/Product/Store',
  GET_STORE_PRODUCT_IMAGES: '/Product/Store/{id}/Images',
  PATCH_PRODUCT_TO_STORE_ORDER: '/User/Store/Order/Current/{id}', // Sets the quantity of the product in the order
  GET_USER_CURRENT_STORE_ORDER: '/User/Store/Order/Current',
  ADD_PRODUCT_TO_STORE_ORDER: '/User/Store/Order/Current/Add',
  GET_USER_STORE_CREDITS: '/User/Store/Credits',
  POST_VIA_EMAIL: '/User/Store/Order/{id}/SendReceipt',
  GET_USER_STORE_ORDERS: '/User/Store/Order',
  GET_USER_STORE_ORDER_DETAIL: '/User/Store/Order/{id}',
  GET_STORE_PRODUCT_CATEGORY: '/Product/Store/Category',

  // Club Detail
  GET_ALL_CLUB_REVIEWS: '/Club/Reviews',
  GET_CLUB_DETAIL: '/Club/{ID}',
  POST_CREATE_UPDATE_CLUB_VOTE: '/Club/{ID}/Vote',
  GET_CLUB_EVENT: '/Club/{ID}/Event',
  GET_CLUB_VOTE_COMMENTS: '/Club/{ID}/VoteComment',

  // Gifts
  GET_LIST_GIFTS: '/Consumables/Gifts',
  GET_GIFT_REPLIES: '/Lookup/GiftReplies',
  GET_GIFTS_RECEIVED: '/User/Gift',
  GIVE_GIFT: '/Profile/{UserID}/Gift',
  REDEEM_RECEIVED_GIFT: '/User/Gift/{GiftID}/Redeem',
  FORFEIT_RECEIVED_GIFT: '/User/Gift/{GiftID}/Forfeit',

  // Article Author detail
  GET_ARTICLE_AUTHOR_DETAIL: '/Article/Author/{AuthorID}',
  GET_ARTICLE_AUTHORS: '/Article/Author',
  GET_ARTICLES: '/Article',

  GET_ACTIVE_SUBMISSION_COUNT: '/User/ActiveSubmission/Count?RecipientUserID={RecipientUserID}',
  GOOGLE_MAP_URL: 'https://www.google.com/maps/search/?api=1&query={lat},{lng}',
  // Validation Search
  GET_VALIDATION_SEARCH: '/Profile/Validation',

  DELETE_SHARED_MEDIA: '/receiver/{receiverXmppId}/medias',
  GET_SHARED_MEDIA: '/receiver/{receiverXmppId}/media',
  GET_SHARED_MEDIA_BY_DIRECTION: '/receiver/{receiverXmppId}/gallery',
  SEND_EVENT_GROUP_CHAT_MASS_MSG: '/User/Notification/Announcement',
  GET_USER_CONVERSATION_STATUS: 'users/status',

  // Upload user photo banner
  CREATE_USER_PHOTO_BANNER: '/User/Photo/ConversationBanner',

  // Verify member of group chat
  GET_GROUP_CHAT_MEMBER: '/groups-chat/{roomJid}/member/{userId}',
  GET_CURRENT_GROUP_CHAT_MEMBER_STATUS: '/groups-chat/{roomJid}/member/status',
  // GET GROUP CHAT STATUS
  GET_GROUP_CHAT_USER_MESSAGE_STATUS: '/User/Message/Status',

  REMOVE_GROUP_CHAT_TOKEN: '/groups-chat/{roomJid}/shareRevoke',

  // LIVENESS
  GET_USER_LIVENESS_SESSION_ID: '/User/Liveness/Session',
  GET_USER_LIVENESS_RESULT: '/User/Liveness/Result',
  // Consumable
  GET_LIST_PROFILE_BOOST: '/Consumables/ProfileBoost',
  GET_LIST_CONVERSATION_BOOST: '/Consumables/ConversationBoost',
  POST_PURCHASE_CONSUMABLE_PRODUCT: '/User/Consumable/Purchase',
  GET_PROFILE_CHANGE_PRODUCT: '/Consumables/Incidentals',
  GET_LIST_LIKE_PRODUCT: '/Consumables/Likes',
  GET_LIST_FAVS_PRODUCT: '/Consumables/Favs',
  GET_LIST_INVITES_CREDIT_PRODUCT: '/Consumables/InviteCredits',
  GET_USER_REMAINING_INVITES_CREDIT: '/User/Invite/Credits',
  // ProfileBoost Stats
  GET_USER_PROFILE_BOOST_STATS: '/User/ProfileBoost/Stats',

  // Photo likes
  GET_PHOTO_LIKES: '/Profile/Photo/{PhotoID}/LikeResult',
  CREATE_USER_PHOTO_LIKE: '/Profile/Photo/{PhotoID}/Like',
  DELETE_USER_PHOTO_LIKE: '/Profile/Photo/{PhotoID}/Like',
  POST_CREATE_PROFILE_VIEW: '/Profile/{Id}/View',
  // Photo Status
  CHECK_PHOTO_STATUS: '/Profile/Photo/{PhotoID}/Status',
  // Get User Profile Activity
  GET_PROFILE_ACTIVITY: '/Profile/{Id}/Activity',

  // GROUP
  GET_JOINED_GROUP: '/Club/Joined',
  GET_MY_GROUP: '/User/Club',
  SEARCH_GROUP: '/Club/SearchGroup',
  SEARCH_GROUP_BY_NAME: '/Club/Search/Name',
  SEARCH_GROUP_BY_TAG_NAME: '/Club/Tag/Search',
  SEARCH_GROUP_BY_TAG_ID: '/Club/Search/Tag/{Id}',
  GET_RECOMMENDED_GROUPS: '/Club/Recommended	',

  //GROUP MANAGEMENT
  CREATE_GROUP: '/User/Club',
  USER_GROUP_DETAIL: '/User/Club/{ClubId}',
  UPLOAD_GROUP_PHOTO: '/User/Club/{ClubId}/Photo',
  REMOVE_A_PHOTO_GROUP: '/User/Club/{ClubId}/Photo/{PhotoId}',
  SET_SORT_PHOTO_NUMBER: '/User/Club/{ClubId}/Photo/{PhotoId}/SortNumber',
  GET_LIST_JOINED_USERS: '/User/Club/{ClubId}/User/Joined',
  GET_LIST_REQUESTED_USERS: '/User/Club/{ClubId}/User/Request',
  APPROVE_USER_REQUEST: '/User/Club/{ClubId}/User/Approve',
  REMOVE_USER_REQUEST: '/User/Club/{ClubId}/User/Remove',
  PATCH_CLUB_USER_MEMBER_LEVEL: '/User/Club/{ClubID}/User/{UserID}/MemberLevel',
  PATCH_CLUB_USER_BAN_POSTING: '/User/Club/{ClubID}/User/{UserID}/BanPosting',
  GENERATE_GROUP_TOKEN: 'UserClub/{ClubId}/InvitationToken',

  //GROUP EVENTS
  GROUP_MANAGAMENT_EVENTS: '/User/Club/{ClubId}/Event',
  USER_GROUP_EVENT: '/User/Club/{ClubId}/Event/{EventId}',
  REMOVE_GROUP_EVENT_BANNER: '/User/Club/{ClubId}/Event/{EventId}/Banner',
  NOTIFY_MYSELF: '/send/notification/me',
  POST_CREATE_USER_CLUB_MEDIA_VIDEO_URL: '/User/Club/Media/Video',

  // GROUP DETAILS
  GET_GROUP_DETAIL: 'Club/{ClubId}',
  GET_GROUP_JOINED_USERS: 'Club/{ClubId}/JoinedUser',
  GET_GROUP_DETAIL_OWNER: 'User/Club/{ClubId}',
  JOIN_GROUP: '/Club/{ClubId}/Join',
  ACCEPT_INVITATION_GROUP: '/Club/{ClubId}/AcceptInvitation',
  REJECT_INVITATION_GROUP: '/Club/{ClubId}/RejectInvitation',
  LEAVE_GROUP: '/Club/{ClubId}/Leave',
  JOIN_PRIVATE_GROUP: '/Club/{ClubId}/JoinPrivate',
  LEAVE_PRIVATE_GROUP: '/Club/{ClubId}/LeavePrivate',
  VOTE_GROUP: '/Club/{ClubId}/Vote',
  COMMENT_GROUP: '/Club/{ClubId}/Comment',
  GET_GROUP_VOTE_COMMENTS: '/Club/{ClubId}/VoteComment',
  GET_GROUP_EVENTS: '/Club/{ClubId}/Event',
  GET_GROUP_EVENTS_OWNER: 'User/Club/{ClubId}/Event',
  GET_GROUP_PHOTOS: '/Club/{ClubId}/Photo',
  GET_GROUP_PHOTOS_OWNER: 'User/Club/{ClubId}/Photo',
  POST_CREATE_GROUP_POST: '/User/Club/{ClubID}/Post',
  GET_GROUP_ACTIVITY: '/Club/{ClubId}/Activity',
  GET_GROUP_ACTIVITY_OWNER: 'User/Club/{ClubId}/Activity',
  GET_GROUP_ALBUMS: '/Club/{ClubId}/Album',
  GET_GROUP_ALBUMS_OWNER: 'User/Club/{ClubId}/Album',
  GET_GROUP_VIDEO: '/Club/{ClubId}/Video',
  GET_GROUP_VIDEO_OWNER: 'User/Club/{ClubId}/Video',
  LOOK_UP_GROUP_TAGS: '/Club/Tag/Search',
  CLUB_MEDIA_COMMENT: '/Club/Media/{Id}/Comment',
  CLUB_MEDIA_LIKE: '/Club/Media/{Id}/Like',
  CLUB_ALBUM_COMMENT: '/Club/Album/{Id}/Comment',
  CLUB_ALBUM_LIKE: '/Club/Album/{Id}/Like',
  CLUB_POST_COMMENT: '/Club/Post/{Id}/Comment',
  CLUB_POST_LIKE: '/Club/Post/{Id}/Like',
  GET_CLUB_POST_LIKES: '/Club/Post/{Id}/Like',
  GET_CLUB_POST_DETAIL: 'Club/Post/{PostID}',
  GET_CLUB_POST_DETAIL_OWNER: 'User/Club/Post/{PostID}',
  GET_USER_CLUB_ALERT_BY_CLUB_ID: '/User/Club/{ClubID}/Alerts',
  GET_CLUB_FRIENDS: '/Club/{ClubID}/Friends',
  POST_CLUB_BANNER: '/User/Club/{ClubID}/Banner',
  POST_INVITE_USER_TO_JOIN: '/User/Club/{ClubID}/User/Invite',
  POST_ACCECPT_INVITATION: '/Club/{ClubID}/AcceptInvitation',
  POST_REJECT_INVITATION: '/Club/{ClubID}/RejectInvitation',
  GET_CLUB_ALBUM_MEDIA: '/Club/Album/{AlbumID}/Media',
  GET_CLUB_TAG_PUPOLAR: '/Club/Tag/Popular',
  GET_CLUB_USER_ACTIVITIES: '/User/Club/{ClubID}/UserActivity',
  GET_CLUB_ALBUM_MEDIA_OWNER: 'User/Club/Album/{AlbumID}/Media',
  USER_CLUB_POST: 'User/Club/Post/{PostID}',
  CREATE_USER_CLUB_POST: 'User/Club/{ClubID}/Post',
  CREATE_USER_CLUB_ALBUM: '/User/Club/{ClubID}/Album',
  POST_CREATE_MEDIA_PHOTO: 'User/Club/Media/Photo',
  DELETE_CLUB_MEDIA: 'User/Club/Media/{MediaID}',
  GET_CLUB_LIST_CAN_SHARE: '/User/Club/InviteList',
  GET_CLUB_EVENT_EXPRESS_INTEREST: '/User/Club/{ClubID}/Event/Interests',
  DELETE_CLUB_POST_MEDIAS: '/User/Club/Post/{PostID}/Media',
  DELETE_CLUB_ALBUM_MEDIAS: '/User/Club/Album/{AlbumID}/Media',
  RE_ORDER_USER_CLUB_POST_MEDIA: '/Club/Media/Post/{PostID}/ReOrder',
  RE_ORDER_USER_CLUB_ALBUM_MEDIA: '/Club/Media/Album/{AlbumID}/ReOrder',
  GET_CLUB_ALBUM_DETAIL: '/Club/Album/{AlbumID}',
  USER_CLUB_ALBUM: '/User/Club/Album/{AlbumID}',
  MERGE_CLUB_VIDEO_ASYNC: 'User/Club/Media/Video/MergeAsync',
  VIDEO_UPLOAD_PROGRESS: 'User/Video/UploadProgress',
  USER_CLUB_VIDEO_UPLOAD_PROGRESS: 'User/Club/Media/Video/UploadProgress',
  VIDEO_UPLOAD_CHUNKS: 'FileUpload/Chunks',
  VIDEO_UPLOAD_CHUNKS_STRING: 'fileupload/chunks/string',
  GET_CLUB_POST_MEDIA_OWNER: 'User/Club/Post/{PostID}/Media',
  GET_CLUB_POST_MEDIA: 'Club/Post/{PostID}/Media',
  VALIDATE_USER_PASSWORD: '/User/Account/Validate',
  DELETE_CLUB_VOTE_OWNER: 'User/Club/Vote/{VoteID}',
  DELETE_CLUB_VOTE: 'Club/{VoteID}/Vote',
  GET_CLUB_MEDIA: '/Club/Media/{Id}',
  GET_USER_CLUB_MEDIA: 'User/Club/Media/{Id}',

  // GROUP NOTIFICATION
  GET_GROUP_ACTIVITIES_NOTIFICATION: '/User/Club/UserActivity',
  GET_GROUP_JOIN_REQUEST_NOTIFICATION: '/User/Club/User/Request',
  SET_CHAT_ROOM_REMINDER: '/Chat/Rooms/{RoomID}/Reminder',
  DELETE_CHAT_ROOM_REMINDER: '/Chat/Rooms/{RoomID}/Reminder',
  GET_GROUP_SUGGESTED_MEMBERS: '/User/Club/{ClubID}/SuggestedUsers',
  GET_SUGGESTED_GROUP: '/Club/Suggested',
  GET_USER_INVITE_CREDITS: '/User/Invite/Credits',
  POST_USER_INVITE: '/User/Invite',
  GET_EVENT_RECEIVED_INVITES: '/User/Invite/Received/2',
  GET_GROUP_RECEIVED_INVITES: '/User/Invite/Received/1',
  GET_GROUP_RECENT_ACTIVITY: '/Club/Activity',
  // GROUP DETAILS
  GET_GROUP_DETAIL: 'Club/{ClubId}',
  GET_GROUP_DETAIL_OWNER: 'User/Club/{ClubId}',
  GET_GROUP_JOINED_USERS: 'Club/{ClubId}/JoinedUser',
  JOIN_GROUP: '/Club/{ClubId}/Join',
  ACCEPT_INVITATION_GROUP: '/Club/{ClubId}/AcceptInvitation',
  REJECT_INVITATION_GROUP: '/Club/{ClubId}/RejectInvitation',
  LEAVE_GROUP: '/Club/{ClubId}/Leave',
  JOIN_PRIVATE_GROUP: '/Club/{ClubId}/JoinPrivate',
  LEAVE_PRIVATE_GROUP: '/Club/{ClubId}/LeavePrivate',
  VOTE_GROUP: '/Club/{ClubId}/Vote',
  COMMENT_GROUP: '/Club/{ClubId}/Comment',
  GET_GROUP_VOTE_COMMENTS: '/Club/{ClubId}/VoteComment',
  GET_GROUP_EVENTS: '/Club/{ClubId}/Event',
  GET_GROUP_EVENTS_OWNER: 'User/Club/{ClubId}/Event',
  GET_GROUP_PHOTOS: '/Club/{ClubId}/Photo',
  GET_GROUP_PHOTOS_OWNER: 'User/Club/{ClubId}/Photo',
  POST_CREATE_GROUP_POST: '/User/Club/{ClubID}/Post',
  GET_GROUP_ACTIVITY: '/Club/{ClubId}/Activity',
  GET_GROUP_ACTIVITY_OWNER: 'User/Club/{ClubId}/Activity',
  GET_GROUP_ALBUMS: '/Club/{ClubId}/Album',
  GET_GROUP_ALBUMS_OWNER: 'User/Club/{ClubId}/Album',
  GET_GROUP_VIDEO: '/Club/{ClubId}/Video',
  GET_GROUP_VIDEO_OWNER: 'User/Club/{ClubId}/Video',
  LOOK_UP_GROUP_TAGS: '/Club/Tag/Search',
  CLUB_MEDIA_COMMENT: '/Club/Media/{Id}/Comment',
  CLUB_MEDIA_LIKE: '/Club/Media/{Id}/Like',
  CLUB_ALBUM_COMMENT: '/Club/Album/{Id}/Comment',
  CLUB_ALBUM_LIKE: '/Club/Album/{Id}/Like',
  CLUB_POST_COMMENT: '/Club/Post/{Id}/Comment',
  CLUB_POST_LIKE: '/Club/Post/{Id}/Like',
  GET_CLUB_POST_LIKES: '/Club/Post/{Id}/Like',
  GET_CLUB_POST_DETAIL: 'Club/Post/{PostID}',
  GET_CLUB_POST_DETAIL_OWNER: 'User/Club/Post/{PostID}',
  GET_USER_CLUB_ALERT: '/User/Club/{ClubID}/Alerts',
  GET_CLUB_FRIENDS: '/Club/{ClubID}/Friends',
  POST_CLUB_BANNER: '/User/Club/{ClubID}/Banner',
  POST_INVITE_USER_TO_JOIN: '/User/Club/{ClubID}/User/Invite',
  POST_ACCECPT_INVITATION: '/Club/{ClubID}/AcceptInvitation',
  POST_REJECT_INVITATION: '/Club/{ClubID}/RejectInvitation',
  GET_CLUB_ALBUM_MEDIA: '/Club/Album/{AlbumID}/Media',
  GET_CLUB_TAG_PUPOLAR: '/Club/Tag/Popular',
  GET_CLUB_USER_ACTIVITIES: '/User/Club/{ClubID}/UserActivity',
  GET_CLUB_ALBUM_MEDIA_OWNER: 'User/Club/Album/{AlbumID}/Media',
  USER_CLUB_POST: 'User/Club/Post/{PostID}',
  CREATE_USER_CLUB_POST: 'User/Club/{ClubID}/Post',
  CREATE_USER_CLUB_ALBUM: '/User/Club/{ClubID}/Album',
  POST_CREATE_MEDIA_PHOTO: 'User/Club/Media/Photo',
  DELETE_CLUB_MEDIA: 'User/Club/Media/{MediaID}',
  GET_CLUB_LIST_CAN_SHARE: '/User/Club/InviteList',
  POST_INVITE_USER_TO_JOIN: '/User/Club/{ClubID}/User/Invite',
  POST_ACCECPT_INVITATION: '/Club/{ClubID}/AcceptInvitation',
  POST_REJECT_INVITATION: '/Club/{ClubID}/RejectInvitation',
  GET_CLUB_ALBUM_MEDIA: '/Club/Album/{AlbumID}/Media',
  GET_CLUB_TAG_PUPOLAR: '/Club/Tag/Popular',
  GET_CLUB_USER_ACTIVITIES: '/User/Club/{ClubID}/UserActivity',
  GET_CLUB_EVENT_EXPRESS_INTEREST: '/User/Club/{ClubID}/Event/Interests',
  GET_CLUB_ALBUM_MEDIA_OWNER: 'User/Club/Album/{AlbumID}/Media',
  USER_CLUB_POST: 'User/Club/Post/{PostID}',
  CREATE_USER_CLUB_POST: 'User/Club/{ClubID}/Post',
  CREATE_USER_CLUB_ALBUM: '/User/Club/{ClubID}/Album',
  POST_CREATE_MEDIA_PHOTO: 'User/Club/Media/Photo',
  DELETE_CLUB_MEDIA: 'User/Club/Media/{MediaID}',
  DELETE_CLUB_POST_MEDIAS: '/User/Club/Post/{PostID}/Media',
  DELETE_CLUB_ALBUM_MEDIAS: '/User/Club/Album/{AlbumID}/Media',
  RE_ORDER_USER_CLUB_POST_MEDIA: '/Club/Media/Post/{PostID}/ReOrder',
  RE_ORDER_USER_CLUB_ALBUM_MEDIA: '/Club/Media/Album/{AlbumID}/ReOrder',
  GET_CLUB_ALBUM_DETAIL: '/Club/Album/{AlbumID}',
  USER_CLUB_ALBUM: '/User/Club/Album/{AlbumID}',
  MERGE_CLUB_VIDEO_ASYNC: 'User/Club/Media/Video/MergeAsync',
  VIDEO_UPLOAD_PROGRESS: 'User/Video/UploadProgress',
  USER_CLUB_VIDEO_UPLOAD_PROGRESS: 'User/Club/Media/Video/UploadProgress',
  VIDEO_UPLOAD_CHUNKS: 'FileUpload/Chunks',
  VIDEO_UPLOAD_CHUNKS_STRING: 'fileupload/chunks/string',
  GET_CLUB_POST_MEDIA_OWNER: 'User/Club/Post/{PostID}/Media',
  GET_CLUB_POST_MEDIA: 'Club/Post/{PostID}/Media',
  VALIDATE_USER_PASSWORD: '/User/Account/Validate',
  DELETE_CLUB_VOTE_OWNER: 'User/Club/Vote/{VoteID}',
  DELETE_CLUB_VOTE: 'Club/{VoteID}/Vote',
  GET_CLUB_MEDIA: '/Club/Media/{Id}',
  GET_USER_CLUB_MEDIA: 'User/Club/Media/{Id}',
  // GROUP DETAILS
  GET_GROUP_DETAIL: 'Club/{ClubId}',
  GET_GROUP_DETAIL_OWNER: 'User/Club/{ClubId}',
  GET_GROUP_JOINED_USERS: 'Club/{ClubId}/JoinedUser',
  JOIN_GROUP: '/Club/{ClubId}/Join',
  ACCEPT_INVITATION_GROUP: '/Club/{ClubId}/AcceptInvitation',
  REJECT_INVITATION_GROUP: '/Club/{ClubId}/RejectInvitation',
  LEAVE_GROUP: '/Club/{ClubId}/Leave',
  JOIN_PRIVATE_GROUP: '/Club/{ClubId}/JoinPrivate',
  LEAVE_PRIVATE_GROUP: '/Club/{ClubId}/LeavePrivate',
  VOTE_GROUP: '/Club/{ClubId}/Vote',
  COMMENT_GROUP: '/Club/{ClubId}/Comment',
  GET_GROUP_VOTE_COMMENTS: '/Club/{ClubId}/VoteComment',
  GET_GROUP_EVENTS: '/Club/{ClubId}/Event',
  GET_GROUP_EVENTS_OWNER: 'User/Club/{ClubId}/Event',
  GET_GROUP_PHOTOS: '/Club/{ClubId}/Photo',
  GET_GROUP_PHOTOS_OWNER: 'User/Club/{ClubId}/Photo',
  POST_CREATE_GROUP_POST: '/User/Club/{ClubID}/Post',
  GET_GROUP_ACTIVITY: '/Club/{ClubId}/Activity',
  GET_GROUP_ACTIVITY_OWNER: 'User/Club/{ClubId}/Activity',
  GET_GROUP_ALBUMS: '/Club/{ClubId}/Album',
  GET_GROUP_ALBUMS_OWNER: 'User/Club/{ClubId}/Album',
  GET_GROUP_VIDEO: '/Club/{ClubId}/Video',
  GET_GROUP_VIDEO_OWNER: 'User/Club/{ClubId}/Video',
  LOOK_UP_GROUP_TAGS: '/Club/Tag/Search',
  CLUB_MEDIA_COMMENT: '/Club/Media/{Id}/Comment',
  CLUB_MEDIA_LIKE: '/Club/Media/{Id}/Like',
  CLUB_ALBUM_COMMENT: '/Club/Album/{Id}/Comment',
  CLUB_ALBUM_LIKE: '/Club/Album/{Id}/Like',
  CLUB_POST_COMMENT: '/Club/Post/{Id}/Comment',
  CLUB_POST_LIKE: '/Club/Post/{Id}/Like',
  GET_CLUB_POST_LIKES: '/Club/Post/{Id}/Like',
  GET_CLUB_POST_DETAIL: 'Club/Post/{PostID}',
  GET_CLUB_POST_DETAIL_OWNER: 'User/Club/Post/{PostID}',
  GET_USER_CLUB_ALERT: '/User/Club/Alerts',
  GET_CLUB_FRIENDS: '/Club/{ClubID}/Friends',
  POST_CLUB_BANNER: '/User/Club/{ClubID}/Banner',
  GET_CLUB_LIST_CAN_SHARE: '/User/Club/InviteList',
  POST_INVITE_USER_TO_JOIN: '/User/Club/{ClubID}/User/Invite',
  POST_ACCECPT_INVITATION: '/Club/{ClubID}/AcceptInvitation',
  POST_REJECT_INVITATION: '/Club/{ClubID}/RejectInvitation',
  GET_CLUB_ALBUM_MEDIA: '/Club/Album/{AlbumID}/Media',
  GET_CLUB_TAG_PUPOLAR: '/Club/Tag/Popular',
  GET_CLUB_USER_ACTIVITIES: '/User/Club/{ClubID}/UserActivity',
  GET_CLUB_ALBUM_MEDIA_OWNER: 'User/Club/Album/{AlbumID}/Media',
  USER_CLUB_POST: 'User/Club/Post/{PostID}',
  CREATE_USER_CLUB_POST: 'User/Club/{ClubID}/Post',
  CREATE_USER_CLUB_ALBUM: '/User/Club/{ClubID}/Album',
  POST_CREATE_MEDIA_PHOTO: 'User/Club/Media/Photo',
  GET_CLUB_EVENT_EXPRESS_INTEREST: '/User/Club/{ClubID}/Event/Interests',
  DELETE_CLUB_MEDIA: 'User/Club/Media/{MediaID}',
  GET_CLUB_ALBUM_DETAIL: '/Club/Album/{AlbumID}',
  USER_CLUB_ALBUM: '/User/Club/Album/{AlbumID}',
  MERGE_CLUB_VIDEO_ASYNC: 'User/Club/Media/Video/MergeAsync',
  VIDEO_UPLOAD_PROGRESS: 'User/Video/UploadProgress',
  USER_CLUB_VIDEO_UPLOAD_PROGRESS: 'User/Club/Media/Video/UploadProgress',
  VIDEO_UPLOAD_CHUNKS: 'FileUpload/Chunks',
  VIDEO_UPLOAD_CHUNKS_STRING: 'fileupload/chunks/string',
  GET_CLUB_POST_MEDIA_OWNER: 'User/Club/Post/{PostID}/Media',
  GET_CLUB_POST_MEDIA: 'Club/Post/{PostID}/Media',
  VALIDATE_USER_PASSWORD: '/User/Account/Validate',
  DELETE_CLUB_VOTE_OWNER: 'User/Club/Vote/{VoteID}',
  DELETE_CLUB_VOTE: 'Club/{VoteID}/Vote',
  GET_CLUB_MEDIA: '/Club/Media/{Id}',
  // GROUP NOTIFICATION
  GET_GROUP_ACTIVITIES_NOTIFICATION: '/User/Club/UserActivity',
  GET_GROUP_JOIN_REQUEST_NOTIFICATION: '/User/Club/User/Request',
  GET_USER_CLUB_NEW_USERS: '/User/Club/User/New',
  GET_USER_GROUP_NEW_USERS: '/User/Club/{ClubID}/User/New',
  GET_GROUP_SUGGESTED_MEMBERS: '/User/Club/{ClubID}/SuggestedUsers',
  GET_EVENT_RECEIVED_INVITES: '/User/Invite/Received/Event',
  GET_GROUP_RECEIVED_INVITES: '/User/Invite/Received/Group',
  DELETE_EVENT_RECEIVED_INVITES: '/User/Invite/Received/{InviteID}',
  DELETE_GROUP_RECEIVED_INVITES: '/User/Invite/Received/{InviteID}',
  POST_BLOCK_GROUP: '/Club/{ClubID}/Block',
};

if (process.env.REACT_APP_IS_PRODUCTION === 'true') {
  // POINT TO PRODUCTION SERVER
  urls = {
    ...urls,
    XMPP_IMURL: 'wss://chatxmpp.redhotpie.com.au:5222/',
    BASE_URL: 'https://chatapi.redhotpie.com.au',
    XMPP_BASE: 'chatxmpp.redhotpie.com.au',
    BASE_RHPURL: 'https://srvsr.redhotpie.com.au',
    AUT_RHPURL: 'https://authr.redhotpie.com.au',
    LIVE_STREAM_HOST: 'https://srv5330.mjhst.com:5443/WebRTCAppEE/rest',
    WSS_LIVE_STREAM: 'wss://srv5330.mjhst.com:5443/WebRTCAppEE/websocket',
    FACE_LIVENESS_SERVER: 'https://flr.redhotpie.com.au:41101',
  };
}

export default urls;
